module.exports = __webpack_public_path__ + "img/ic_linkedIn.c16597c0.svg";